import React, { useState, useEffect } from 'react';
import { FaBirthdayCake, FaCheck, FaTimes } from 'react-icons/fa';

const AgeVerification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('ageVerified');
    if (!verified) {
      setIsVisible(true);
    } else {
      setIsVerified(true);
    }
  }, []);

  const handleVerify = (isAdult: boolean) => {
    if (isAdult) {
      localStorage.setItem('ageVerified', 'true');
      setIsVerified(true);
      setIsVisible(false);
    } else {
      alert('You must be 18 or older to access this website.');
    }
  };

  if (!isVisible || isVerified) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-dark-900/95 backdrop-blur-sm">
      <div className="glass rounded-2xl p-8 max-w-md mx-4 transform animate-float">
        <div className="text-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-quantum-400 to-quantum-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <FaBirthdayCake className="w-10 h-10 text-dark-900" />
          </div>
          <h2 className="text-3xl font-bold text-white mb-2">Age Verification</h2>
          <p className="text-gray-400">
            You must be 18 or older to access this website. Please confirm your age to continue.
          </p>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => handleVerify(true)}
            className="w-full bg-gradient-to-r from-quantum-500 to-quantum-600 text-white py-4 px-6 rounded-lg font-semibold flex items-center justify-center space-x-2 hover:from-quantum-600 hover:to-quantum-700 transition-all transform hover:scale-105 shadow-lg shadow-quantum-500/30"
          >
            <FaCheck className="w-5 h-5" />
            <span>I am 18 or older</span>
          </button>
          <button
            onClick={() => handleVerify(false)}
            className="w-full bg-dark-700 text-gray-300 py-4 px-6 rounded-lg font-semibold flex items-center justify-center space-x-2 hover:bg-dark-600 transition-all"
          >
            <FaTimes className="w-5 h-5" />
            <span>I am under 18</span>
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center mt-6">
          By entering this site, you agree to our Terms & Conditions and Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

